"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrepErrorCodes = void 0;
exports.PrepErrorCodes = {
    BARCODE_TRANSLATION_DPID_MISMATCH: "BARCODE_TRANSLATION_DPID_MISMATCH",
    BARCODE_TRANSLATION_INVALID_INPUT_MAP: "BARCODE_TRANSLATION_INVALID_INPUT_MAP",
    BARCODE_TRANSLATION_NOT_ALLOWED: "BARCODE_TRANSLATION_NOT_ALLOWED",
    BARCODE_TRANSLATION_OUTPUT_BARCODE_NOT_FOUND: "BARCODE_TRANSLATION_OUTPUT_BARCODE_NOT_FOUND",
    BARCODE_TRANSLATION_PRODUCT_NOT_FOUND: "BARCODE_TRANSLATION_PRODUCT_NOT_FOUND",
    BCL_NOT_FOUND: "BCL_NOT_FOUND",
    BILLING_ALREADY_DEACTIVATED: "BILLING_ALREADY_DEACTIVATED",
    BILLING_INVOICE_OPTIONS_NOT_PROVIDED: "BILLING_INVOICE_OPTIONS_NOT_PROVIDED",
    BOX_BUILDING_CANNOT_BE_COMPLETED_WITHOUT_BOX_SIZES: "BOX_BUILDING_CANNOT_BE_COMPLETED_WITHOUT_BOX_SIZES",
    BOX_CONFIGURATION_ALREADY_FINALIZED: "BOX_CONFIGURATION_ALREADY_FINALIZED",
    BOX_CONFIGURATION_BARCODE_PRODUCT_NOT_FOUND: "BOX_CONFIGURATION_BARCODE_PRODUCT_NOT_FOUND",
    BOX_CONFIGURATION_BARCODE_SELLER_MISMATCH: "BOX_CONFIGURATION_BARCODE_SELLER_MISMATCH",
    BOX_CONFIGURATION_DPID_MISMATCH: "BOX_CONFIGURATION_DPID_MISMATCH",
    BOX_CONFIGURATION_DPID_INACTIVE: "BOX_CONFIGURATION_DPID_INACTIVE",
    BOX_CONFIGURATION_FINALIZED_NUM_BOXES_REQUESTED_MISMATCH: "BOX_CONFIGURATION_FINALIZED_NUM_BOXES_REQUESTED_MISMATCH",
    BOX_CONFIGURATION_HAS_NO_ITEMS: "BOX_CONFIGURATION_HAS_NO_ITEMS",
    BOX_CONFIGURATION_INVALID_NUMBER_OF_BOXES: "BOX_CONFIGURATION_INVALID_NUMBER_OF_BOXES",
    BOX_CONFIGURATION_ITEM_ALREADY_EXISTS: "BOX_CONFIGURATION_ITEM_ALREADY_EXISTS",
    BOX_CONFIGURATION_ITEM_DSKU_NOT_FOUND: "BOX_CONFIGURATION_ITEM_DSKU_NOT_FOUND",
    BOX_CONFIGURATION_ITEM_QTY_INVALID: "BOX_CONFIGURATION_ITEM_QTY_INVALID",
    BOX_CONFIGURATION_NOT_ALLOWED: "BOX_CONFIGURATION_NOT_ALLOWED",
    BOX_CONFIGURATION_NOT_FOUND: "BOX_CONFIGURATION_NOT_FOUND",
    BOX_CONFIGURATION_PACKAGES_ALREADY_GENERATED: "BOX_CONFIGURATION_PACKAGES_ALREADY_GENERATED",
    BOX_CONTENT_LABELS_NOT_ALLOWED: "BOX_CONTENT_LABELS_NOT_ALLOWED",
    BOX_CONTENT_LABELS_ONLY_ALLOWED_FOR_SHIPPING_PLAN: "BOX_CONTENT_LABELS_ONLY_ALLOWED_FOR_SHIPPING_PLAN",
    CANNOT_ADD_DSKU_MAX_REACHED_BOX_CONFIGURATION: "CANNOT_ADD_DSKU_MAX_REACHED_BOX_CONFIGURATION",
    CANNOT_PRINT_BCLS_IF_PACKAGES_NOT_GENERATED: "CANNOT_PRINT_BCLS_IF_PACKAGES_NOT_GENERATED",
    CANNOT_REMOVE_ITEMS_FROM_COMPLETED_PREP_JOB: "CANNOT_REMOVE_ITEMS_FROM_COMPLETED_PREP_JOB",
    CANNOT_UPDATE_FACILITY_ID_IN_CURRENT_STATE: "CANNOT_UPDATE_FACILITY_ID_IN_CURRENT_STATE",
    CANNOT_UPDATE_NON_DRAFT_BOX_CONFIGURATION: "CANNOT_UPDATE_NON_DRAFT_BOX_CONFIGURATION",
    CARTON_LABEL_CUSTOM_TYPE_MISSING_NAME: "CARTON_LABEL_CUSTOM_TYPE_MISSING_NAME",
    CARTON_LABEL_ALREADY_EXISTS: "CARTON_LABEL_ALREADY_EXISTS",
    CARTON_LABEL_NOT_ALLOWED: "CARTON_LABEL_NOT_ALLOWED",
    CARTON_LABEL_NOT_ON_PREP_JOB: "CARTON_LABEL_NOT_ON_PREP_JOB",
    COMBO_AND_DESTINATION_MISMATCH: "COMBO_AND_DESTINATION_MISMATCH",
    COMPLETED_QUANTITIES_NOT_SUPPORTED: "COMPLETED_QUANTITIES_NOT_SUPPORTED",
    CUSTOM_RATE_ALREADY_EXISTS: "CUSTOM_RATE_ALREADY_EXISTS",
    CUSTOM_RATE_DSKU_REQUIRED_FOR_KITTING: "CUSTOM_RATE_DSKU_REQUIRED_FOR_KITTING",
    CUSTOM_RATE_INVOICE_ITEM_TYPE_NOT_SUPPORTED: "CUSTOM_RATE_INVOICE_ITEM_TYPE_NOT_SUPPORTED",
    CUSTOM_RATE_NOT_FOUND: "CUSTOM_RATE_NOT_FOUND",
    CUSTOM_UNIT_LABEL_DUPLICATE_LABEL_TYPE: "CUSTOM_UNIT_LABEL_DUPLICATE_LABEL_TYPE",
    DSKU_NOT_FOUND: "DSKU_NOT_FOUND",
    EXTERNAL_REQUEST_FAILED: "EXTERNAL_REQUEST_FAILED",
    EXTERNAL_REQUEST_TIMED_OUT: "EXTERNAL_REQUEST_TIMED_OUT",
    FAILED_TO_DUPLICATE_PALLET_LABELS: "FAILED_TO_DUPLICATE_PALLET_LABELS",
    FAILED_TO_FETCH_KIT_INSTRUCTION_FILE: "FAILED_TO_FETCH_KIT_INSTRUCTION_FILE",
    FAILED_TO_GET_CARTON_LABEL_PRESIGNED_URL_FOR_DOWNLOAD: "FAILED_TO_GET_CARTON_LABEL_PRESIGNED_URL_FOR_DOWNLOAD",
    FAILED_TO_GET_PALLET_LABEL_PRESIGNED_URL_FOR_DOWNLOAD: "FAILED_TO_GET_PALLET_LABEL_PRESIGNED_URL_FOR_DOWNLOAD",
    FAILED_TO_LOAD_FILE: "FAILED_TO_LOAD_FILE",
    FAILED_TO_PERSIST_CARTON_LABEL_FILE: "FAILED_TO_PERSIST_CARTON_LABEL_FILE",
    FAILED_TO_PERSIST_KIT_INSTRUCTION_FILE: "FAILED_TO_PERSIST_KIT_INSTRUCTION_FILE",
    FAILED_TO_PERSIST_PALLET_LABEL_FILE: "FAILED_TO_PERSIST_PALLET_LABEL_FILE",
    FAILED_TO_REGISTER_BARCODE: "FAILED_TO_REGISTER_BARCODE",
    FAILED_TO_RETRIEVE_LABEL_FROM_URL: "FAILED_TO_RETRIEVE_LABEL_FROM_URL",
    FLOOR_LOADED_CONTAINER_NOT_ALLOWED: "FLOOR_LOADED_CONTAINER_NOT_ALLOWED",
    FLOOR_LOADED_CONTAINER_NOT_FOUND: "FLOOR_LOADED_CONTAINER_NOT_FOUND",
    GENERATED_INBOUND_PACKAGE_NOT_FOUND: "GENERATED_INBOUND_PACKAGE_NOT_FOUND",
    INVALID_BOX_CONFIGURATION_TRANSITION: "INVALID_BOX_CONFIGURATION_TRANSITION",
    INVALID_PREP_JOB_TRANSITION: "INVALID_PREP_JOB_TRANSITION",
    INVOICE_ITEM_TYPE_DESCRIPTION_NAME_NOT_FOUND: "INVOICE_ITEM_TYPE_DESCRIPTION_NAME_NOT_FOUND",
    KIT_ALREADY_COMPLETED: "KIT_ALREADY_COMPLETED",
    KIT_COMPLETED_CANNOT_REMOVE: "KIT_COMPLETED_CANNOT_REMOVE",
    KIT_COMPLETED_QUANTITY_NOT_FOUND: "KIT_COMPLETED_QUANTITY_NOT_FOUND",
    KIT_DPID_MISMATCH: "KIT_DPID_MISMATCH",
    KIT_DUPLICATE_DSKU: "KIT_DUPLICATE_DSKU",
    KIT_INSTRUCTIONS_NOT_ALLOWED: "KIT_INSTRUCTIONS_NOT_ALLOWED",
    KIT_NOT_FOUND: "KIT_NOT_FOUND",
    KITTING_NOT_ALLOWED: "KITTING_NOT_ALLOWED",
    LABEL_FORMAT_NOT_SUPPORTED: "LABEL_FORMAT_NOT_SUPPORTED",
    LOCATION_HAS_ACTIVE_PREP_JOB: "LOCATION_HAS_ACTIVE_PREP_JOB",
    LOCATION_NOT_FOUND_AT_FACILITY: "LOCATION_NOT_FOUND_AT_FACILITY",
    MANUAL_BILLING_INVALID_INPUT: "MANUAL_BILLING_INVALID_INPUT",
    NON_COMPLIANCE_ALREADY_REPORTED: "NON_COMPLIANCE_ALREADY_REPORTED",
    NON_COMPLIANCE_ALREADY_RESOLVED: "NON_COMPLIANCE_ALREADY_RESOLVED",
    NON_COMPLIANCE_NOT_REPORTED: "NON_COMPLIANCE_NOT_REPORTED",
    NON_NUMERIC_SHIPPING_PLAN_ID: "NON_NUMERIC_SHIPPING_PLAN_ID",
    PALLET_LABEL_ALREADY_EXISTS: "PALLET_LABEL_ALREADY_EXISTS",
    PALLET_LABEL_CANNOT_UPDATE_QUANTITY: "PALLET_LABEL_CANNOT_UPDATE_QUANTITY",
    PALLET_LABEL_NOT_ALLOWED: "PALLET_LABEL_NOT_ALLOWED",
    PALLET_LABEL_NOT_ON_PREP_JOB: "PALLET_LABEL_NOT_ON_PREP_JOB",
    PREP_COMBO_TASK_REMOVAL_WITHOUT_COMBO: "PREP_COMBO_TASK_REMOVAL_WITHOUT_COMBO",
    PREP_JOB_ALREADY_ARCHIVED: "PREP_JOB_ALREADY_ARCHIVED",
    PREP_JOB_ALREADY_ARRIVED: "PREP_JOB_ALREADY_ARRIVED",
    PREP_JOB_ALREADY_COMPLETED: "PREP_JOB_ALREADY_COMPLETED",
    PREP_JOB_ALREADY_EXISTS: "PREP_JOB_ALREADY_EXISTS",
    PREP_JOB_ALREADY_HAS_COMBO: "PREP_JOB_ALREADY_HAS_COMBO",
    PREP_JOB_ALREADY_IN_PROGRESS: "PREP_JOB_ALREADY_IN_PROGRESS",
    PREP_JOB_ALREADY_RECEIVED: "PREP_JOB_ALREADY_RECEIVED",
    PREP_JOB_ARCHIVED: "PREP_JOB_ARCHIVED",
    PREP_JOB_BILLED: "PREP_JOB_BILLED",
    PREP_JOB_CANNOT_CHANGE_SOURCE: "PREP_JOB_CANNOT_CHANGE_SOURCE",
    PREP_JOB_CANNOT_COMPLETE_WITH_NON_COMPLIANCE: "PREP_JOB_CANNOT_COMPLETE_WITH_NON_COMPLIANCE",
    PREP_JOB_COMBO_MISMATCH: "PREP_JOB_COMBO_MISMATCH",
    PREP_JOB_COMPLETION_WITHOUT_ALL_TASKS_COMPLETED: "PREP_JOB_COMPLETION_WITHOUT_ALL_TASKS_COMPLETED",
    PREP_JOB_FACILITY_ID_MISMATCH: "PREP_JOB_FACILITY_ID_MISMATCH",
    PREP_JOB_HAS_NO_FACILITY_ID: "PREP_JOB_HAS_NO_FACILITY_ID",
    PREP_JOB_HAS_NO_TASKS: "PREP_JOB_HAS_NO_TASKS",
    PREP_JOB_NOT_FOR_SHIPPING_PLAN: "PREP_JOB_NOT_FOR_SHIPPING_PLAN",
    PREP_JOB_NOT_FOR_WHOLESALE: "PREP_JOB_NOT_FOR_WHOLESALE",
    PREP_JOB_NOT_FOUND: "PREP_JOB_NOT_FOUND",
    PREP_JOB_NOT_FOUND_FOR_SOURCE_TYPE_AND_ID: "PREP_JOB_NOT_FOUND_FOR_SOURCE_TYPE_AND_ID",
    PREP_JOB_NOT_IN_PROGRESS: "PREP_JOB_NOT_IN_PROGRESS",
    PREP_JOB_PROPERTY_CANNOT_BE_UPDATED: "PREP_JOB_PROPERTY_CANNOT_BE_UPDATED",
    PREP_JOB_REQUEST_DESTINATION_INVALID: "PREP_JOB_REQUEST_DESTINATION_INVALID",
    PREP_JOB_SELLER_ID_MISMATCH: "PREP_JOB_SELLER_ID_MISMATCH",
    PREP_JOB_STATE_INVALID_FOR_MOVING_JOB: "PREP_JOB_STATE_INVALID_FOR_MOVING_JOB",
    PREP_SUBTYPE_NOT_SUPPORTED: "PREP_SUBTYPE_NOT_SUPPORTED",
    PREP_TASK_ALREADY_COMPLETED: "PREP_TASK_ALREADY_COMPLETED",
    PREP_TASK_ALREADY_DEACTIVATED: "PREP_TASK_ALREADY_DEACTIVATED",
    PREP_TASK_ALREADY_REMOVED: "PREP_TASK_ALREADY_REMOVED",
    PREP_TASK_COMPLETE_TASK_NOT_ON_JOB: "PREP_TASK_COMPLETE_TASK_NOT_ON_JOB",
    PREP_TASK_COMPLETION_NOT_ALLOWED: "PREP_TASK_COMPLETION_NOT_ALLOWED",
    PREP_TASK_DUPLICATE_CHARGE: "PREP_TASK_DUPLICATE_CHARGE",
    PREP_TASK_FROM_COMBO_CANNOT_BE_REMOVED_BY_ITSELF: "PREP_TASK_FROM_COMBO_CANNOT_BE_REMOVED_BY_ITSELF",
    PREP_TASK_INVOICE_ITEM_TYPE_NOT_FOUND: "PREP_TASK_INVOICE_ITEM_TYPE_NOT_FOUND",
    PREP_TASK_NOT_ON_PREP_JOB: "PREP_TASK_NOT_ON_PREP_JOB",
    PREP_TASK_REMOVAL_WHEN_TASK_COMPLETED: "PREP_TASK_REMOVAL_WHEN_TASK_COMPLETED",
    RATE_SHEET_ITEM_TYPE_NOT_FOUND: "RATE_SHEET_ITEM_TYPE_NOT_FOUND",
    RATE_SHEET_NOT_FOUND: "RATE_SHEET_NOT_FOUND",
    SHIPPING_PLAN_INVALID: "SHIPPING_PLAN_INVALID",
    SHIPPING_PLAN_SELLER_ID_MISMATCH: "SHIPPING_PLAN_SELLER_ID_MISMATCH",
    SKU_LABELS_NOT_ALLOWED: "SKU_LABELS_NOT_ALLOWED",
    SKU_LABELS_NOT_ALLOWED_FOR_SOURCE_TYPE: "SKU_LABELS_NOT_ALLOWED_FOR_SOURCE_TYPE",
    TASK_CANNOT_BE_COMPLETED_PREP_JOB_NOT_IN_PROGRESS: "TASK_CANNOT_BE_COMPLETED_PREP_JOB_NOT_IN_PROGRESS",
    UNEXPECTED_CODE_PATH: "UNEXPECTED_CODE_PATH",
    UNEXPECTED_WHOLESALE_EVENT_PAYLOAD: "UNEXPECTED_WHOLESALE_EVENT_PAYLOAD",
    UNIT_LABELS_NOT_FOUND: "UNIT_LABELS_NOT_FOUND",
    UNREGISTERED_BARCODE: "UNREGISTERED_BARCODE",
    UPDATE_DESTINATION_REQUEST_INVALID: "UPDATE_DESTINATION_REQUEST_INVALID",
    WHOLESALE_ORDER_NOT_FOUND: "WHOLESALE_ORDER_NOT_FOUND",
    WHOLESALE_SHIPMENT_MISSING_REQUIRED_FIELDS: "WHOLESALE_SHIPMENT_MISSING_REQUIRED_FIELDS",
    WHOLESALE_SHIPMENT_MISSING_REQUIRED_LABELS: "WHOLESALE_SHIPMENT_MISSING_REQUIRED_LABELS",
    WHOLESALE_SHIPMENT_NOT_FOUND: "WHOLESALE_SHIPMENT_NOT_FOUND",
};
//# sourceMappingURL=prep-error-codes.js.map